var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10H7.081L9.781 6.62501C10.126 6.19301 10.056 5.56401 9.625 5.21901C9.194 4.87501 8.564 4.94301 8.219 5.37501L4.219 10.375C3.927 10.741 3.927 11.259 4.219 11.625L8.219 16.625C8.417 16.872 8.707 17 9 17C9.22 17 9.44 16.928 9.625 16.781C10.056 16.436 10.126 15.807 9.781 15.375L7.081 12H16C16.551 12 17 12.449 17 13V18C17 18.552 17.448 19 18 19C18.552 19 19 18.552 19 18V13C19 11.346 17.654 10 16 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLeft);
export default __webpack_public_path__ + "static/media/arrow-up-left.73ecef218ec666cabfcf6c10eed48667.svg";
export { ForwardRef as ReactComponent };